<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Dados da Loja </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${ collapsed ? 'top' : 'bottom' }`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol>
                  <validation-provider
                    name="nome fantasia"
                    rules="required|max:100"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Nome Fantasia"
                      v-model="form.nome_fantasia"
                      :invalid-feedback="errors[0]"                      
                      placeholder="Digite o nome fantasia da sua loja"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <validation-provider
                    name="razão social"
                    rules="required|max:100"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Razão Social"
                      v-model="form.razao_social"
                      :invalid-feedback="errors[0]"
                      placeholder="Digite a razão social da sua loja"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="4">
                  <validation-provider
                    name="CNPJ"
                    rules="required|min:14"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="CNPJ"
                      valid-feedback
                      v-model="form.cnpj"
                      placeholder="Digie seu CNPJ"
                      v-mask="'##.###.###/####-##'"
                      :invalid-feedback="errors[0]"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="2">
                  <validation-provider
                    name="CEP"
                    rules="required|min:8"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="CEP"
                      valid-feedback
                      v-model="form.cep"
                      v-mask="'#####-###'"
                      :invalid-feedback="errors[0]"
                      placeholder="Informe seu CEP"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="3">
                  <validation-provider
                    name="Cidade"
                    rules="required|max:40"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Cidade"
                      valid-feedback
                      v-model="form.cidade"
                      :invalid-feedback="errors[0]"
                      placeholder="Informe a cidade"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="3">
                  <label>Estado</label>
                  <CSelect
                    horizontal
                    :options="estados"
                    :value.sync="form.estado"
                    placeholder="Selecione..."
                    
                    v-model="form.estado"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="4">
                  <validation-provider
                    name="rua"
                    rules="required|max:80"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Rua"
                      valid-feedback
                      v-model="form.logradouro"
                      :invalid-feedback="errors[0]"
                      placeholder="Digie seu endereço"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="número"
                    rules="required|numeric"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Número"
                      type="number"
                      valid-feedback
                      placeholder="Número"
                      v-model="form.numero"
                      :invalid-feedback="errors[0]"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="bairro"
                    rules="required|max:40"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Bairro"
                      v-model="form.bairro"
                      :invalid-feedback="errors[0]"
                      placeholder="Digie seu bairro"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { api } from '@/global'
  export default {
    name: 'dataForm',
    props: {
      show: {
        type: Boolean,
        required: true
      },
      estados: {
        type: Array,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.logistica
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.logistica 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'logistica')
        }
      }
    },
    methods: {
      ...mapActions(['saveDadosLoja', 'updateDatastore']),
      save() {
        this.saveDadosLoja(this.form);
      },
      update() {
        this.updateDatastore(this.form)
      }
    }
  }
</script>
